import React, { useState } from 'react';
import PropTypes from 'prop-types';
import DateFnsUtils from '@date-io/date-fns';
import { DatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  container: {
    display: 'flex',
    flexDirection: 'column'
  }
});

export default function CustomDatePicker(props) {
  const classes = useStyles();
  const [selectedDate, handleDateChange] = useState(new Date());

  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <div className={classes.container}>
        <DatePicker
          open={props.isOpen}
          onOpen={() => props.onOpen()}
          onClose={() => props.onClose()}
          format="d MMM yyyy"
          value={selectedDate}
          onChange={e => {
            handleDateChange(e);
            props.onChange(e);
          }}
          TextFieldComponent={() => null}
        />
      </div>
    </MuiPickersUtilsProvider>
  );
}

CustomDatePicker.propTypes = {
  isOpen: PropTypes.bool,
  onOpen: PropTypes.func,
  onClose: PropTypes.func,
  onChange: PropTypes.func
};
